import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from "react-router-dom"
//import { NavLink} from "react-router-dom";
import axios from 'axios'
import { connectNode } from '../../../utils/global'
import '../../../styles/assets/css/pages/form1.css'
import '../../../styles/assets/css/pages/form2.css'
import { loadLocationWithMessage } from '../../../actions/location'

import '../../../styles/assets/css/pages/stepper1.css'
import { registration_steps } from '../variables/registration.js'
import { trimonthly_steps } from '../variables/assessments.js'
import { question1, question2, no_yes, type_provider,
         reason_service_q1, reason_service_q2 } from '../variables/csi.js'
import Stepper from '@material-ui/core/Stepper'
import Step from '@material-ui/core/Step'
import StepLabel from '@material-ui/core/StepLabel'

import WarningIcon from '@material-ui/icons/Warning'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import CancelIcon from '@material-ui/icons/Cancel'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'

class CsiRedoWoLogin extends Component {
  constructor() {
      super()
      //var [fields, setFields] = useState([{ value: null }])
      this.state = {
          status: false,
          status_submit: true,
          invalid: false,
          message: '',
          start_time: Math.floor(new Date().getTime()/1000),
          start_datetime: new Date().toLocaleString('en-US', { hour12: false }).slice(0, 19).replace('T', ' '),
          next_step: 'final_step',
          uid: 0,
          q1: [-1, -1, -1, -1, -1, '', ''],
          q2: [-1, -1, -1, -1, -1, '', ''],
          q3: [-1, -1, -1, -1, -1, '', ''],
          q4: [-1, -1, -1, -1, -1, '', ''],
          q5: [-1, -1, -1, -1, -1, '', ''],
          q6: [-1, -1, -1, -1, -1, '', ''],
          q7: [-1, -1, -1, -1, -1, '', ''],
          q8: [-1, -1, -1, -1, -1, '', ''],
          q9: [-1, -1, -1, -1, -1, '', ''],
          q10: [-1, -1, -1, -1, -1, '', ''],
          q11: [-1, -1, -1, ''],
          q12: [-1, -1, -1, ''],
          q13: [-1, -1, -1, ''],
          q14: [-1, -1, -1, ''],
          q15: [-1, -1, -1, ''],
          q16: [-1, -1, -1, ''],
      }
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    this.getCompletedData()
  }

  handleChange3 = (e, q, field) => {
    var getVal = this.state['q'+q]
    getVal[field] = e.target.value
    this.setState({
      ['q'+q]: getVal
    })
  }

  getCompletedData = (status) => {
    var timepoint = this.props.match.params.timepoint
    var type = this.props.match.params.type
    var next_step = "complete_assessments"
    axios({
      method: 'post',
      url: connectNode + 'patient/assessment/get_assm_data2',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        uid: this.props.authReducer.uid,
        type: type,
        timepoint: timepoint,
        frm: 'csi',
       }
    }).then((result) => {
      //console.log(result['data'])
      var arr = [[]]
      for(var i = 1; i<=10; i++) {
        arr.push([
          result['data']['q'+i],
          result['data']['q'+i+'_provider'],
          result['data']['q'+i+'_reason'],
          result['data']['q'+i+'_frequency'],
          result['data']['q'+i+'_mins'],
          result['data']['q'+i+'_provider_other'],
          result['data']['q'+i+'_reason_other'],
        ])
      }
      for(var i = 11; i<=16; i++) {
        arr.push([
          result['data']['q'+i],
          result['data']['q'+i+'_duration'],
          result['data']['q'+i+'_reason'],
          result['data']['q'+i+'_reason_other'],
        ])
      }

      this.setState({
        status: status,
        next_step: next_step,
        status_submit: (result['data'].q1 == 0 || result['data'].q1 == 1) ? false : true ,
        q1: arr[1],
        q2: arr[2],
        q3: arr[3],
        q4: arr[4],
        q5: arr[5],
        q6: arr[6],
        q7: arr[7],
        q8: arr[8],
        q9: arr[9],
        q10: arr[10],
        q11: arr[11],
        q12: arr[12],
        q13: arr[13],
        q14: arr[14],
        q15: arr[15],
        q16: arr[16],
      })
    })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    var type = this.props.match.params.type
    var timepoint = this.props.match.params.timepoint
    var uri = 'patient/assessment/update_csi'
    var next_step = 'complete_assessments_wo'

    if(this.state.q1[0] == -1 || this.state.q2[0] == -1 || this.state.q3[0] == -1 ||
      this.state.q4[0] == -1 || this.state.q5[0] == -1 || this.state.q6[0] == -1 ||
      this.state.q7[0] == -1 || this.state.q8[0] == -1 || this.state.q9[0] == -1 ||
      this.state.q10[0] == -1 || this.state.q11[0] == -1 || this.state.q12[0] == -1 ||
      this.state.q13[0] == -1 || this.state.q14[0] === -1 || this.state.q15[0] == -1 ||
      this.state.q16[0] == -1) {
        this.setState({
          message: 'Please fill in all information.',
          invalid: true,
        })
        window.scrollTo(0, 0)
    } else {
      this.setState({
        status_submit: false,
        message: '',
      })
      if(this.state.status_submit) {
        axios({
          method: 'post',
          url: connectNode + uri,
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: {
            uid: this.props.match.params.uid,
            user: this.state,
            type: type,
            timepoint: timepoint,
            next_step: next_step,
          }
        })
        .then((result) => {
          this.props.onLoadLocation('/member/assessment/'+next_step+'/'+type+'/'+timepoint)
          this.props.history.push('/member/assessment/'+next_step+'/'+type+'/'+timepoint)
        })
      } else {
        this.props.onLoadLocation('/member/assessment/'+next_step+'/'+type+'/'+timepoint)
        this.props.history.push('/member/assessment/'+next_step+'/'+type+'/'+timepoint)
      }
    }
  }

  render() {
    return (
      <div className="general_patient_information box_border4">
        <div className="row">
          <div className="small-12 columns headerPage1">
            CSI
          </div>
        </div>
        { this.state.message !== '' &&
        <div className="row warning_msg6">
          <div className="small-12 columns ">
            <div className="float_left1"><WarningIcon /></div>
            <div className="txt_warning_msg1">{ this.state.message }</div>
          </div>
        </div>
        }
        <form id="csi" onSubmit={this.handleSubmit}>
        <div className="row">
          <div className="small-12 columns box2_1 bold">
              <p>Which of the following outside services have you used in the past three months?</p>
              <p>IMPORTANT: Do not include any psychological or other support services you’ve received as a patient in FITT-BD.</p>
          </div>
          <div className="small-12 columns ">
            <div className="box_border5 p_csi">
                <div className="row">
                  <div className="small-12 columns box1">
                    <div className="title_topic1">PSYCHOLOGICAL SERVICES</div>
                    <div className="row top_space">
                    {question1.map(q1 => <>
                      <div className="small-12 medium-8 columns">{q1.label}</div>
                      {no_yes.map(ny =>
                        <div className="small-12 medium-2 columns ">
                        <label class="radio‐flex">
                        <input type="radio" name={'q'+q1.value} key={"ans"+q1.value+ny.value}
                          value={ny.value} checked={this.state['q'+q1.value][0] == ny.value}
                          onChange={(e) => this.handleChange3(e, q1.value, 0)}/>
                          <span>{ny.label}</span>
                        </label></div>)}

                      {this.state['q'+q1.value][0] == 1 && <>
                      <div className="small-12 medium-12 columns">
                        <div className="sep_line_gen2">&nbsp;</div>
                      </div>
                      <div className="bottom_space1">
                        <div className="small-12 medium-5 columns frm_title1">Type of provider</div>
                        <div className="small-12 medium-7 columns">
                        <FormControl variant="outlined" >
                          <Select value={this.state['q'+q1.value][1]} variant="outlined"
                            label="" defaultValue=""
                            onChange={(e) => this.handleChange3(e, q1.value, 1)}>
                              {type_provider.map(each =>
                                <MenuItem key={"provider"+q1.value+each.value} value={each.value}>{each.label}</MenuItem>
                              )}
                          </Select>
                        </FormControl>
                        </div>
                      </div>
                      {this.state['q'+q1.value][1] == 9 &&
                      <div className="bottom_space1">
                        <div className="small-12 medium-5 columns frm_title1">&nbsp;</div>
                        <div className="small-12 medium-7 columns stay_left">
                        <TextField name={'q'+q1.value+'provider'} type='text' className="w100p"
                        value={this.state['q'+q1.value][5]}
                        InputProps={{ inputProps: { name: 'q'+q1.value+'provider', maxLength: 100, placeholder: 'Please specify provider', }}}
                        onChange={(e) => this.handleChange3(e, q1.value, 5)}
                          variant="outlined" />
                        </div>
                      </div>}
                      <div className="bottom_space1">
                        <div className="small-12 medium-5 columns frm_title1">Reason for service</div>
                        <div className="small-12 medium-7 columns">
                        <FormControl variant="outlined" >
                          <Select value={this.state['q'+q1.value][2]} variant="outlined"
                            label="" defaultValue=""
                            onChange={(e) => this.handleChange3(e, q1.value, 2)}>
                              {reason_service_q1.map(each =>
                                <MenuItem key={"provider"+q1.value+each.value} value={each.value}>{each.label}</MenuItem>
                              )}
                          </Select>
                        </FormControl>
                        </div>
                      </div>
                      {this.state['q'+q1.value][2] == 5 &&
                      <div className="bottom_space1">
                        <div className="small-12 medium-5 columns frm_title1">&nbsp;</div>
                        <div className="small-12 medium-7 columns stay_left">
                        <TextField name={'q'+q1.value+'reason'} type='text' className="w100p"
                        value={this.state['q'+q1.value][6]}
                        InputProps={{ inputProps: { name: 'q'+q1.value+'reason', maxLength: 150, placeholder: 'Please specify reason', }}}
                        onChange={(e) => this.handleChange3(e, q1.value, 6)}
                          variant="outlined" />
                        </div>
                      </div>}
                      <div className="bottom_space1">
                        <div className="small-12 medium-5 columns frm_title1">
                        Frequency of service (number of times during the past 90 days service was used)</div>
                        <div className="small-12 medium-2 columns stay_left">
                        <TextField name={'q'+q1.value+'frequency'} type='number'
                          InputProps={{inputProps: {  max: 100, min: 0 }}}
                          value={this.state['q'+q1.value][3]}
                          onChange={(e) => this.handleChange3(e, q1.value, 3)}
                          variant="outlined" />
                        </div>
                      </div>
                      <div className="bottom_space1">
                        <div className="small-12 medium-5 columns frm_title1">Number of minutes/visit</div>
                        <div className="small-12 medium-2 columns stay_left">
                        <TextField name={'q'+q1.value+'visit'} type='number'
                          value={this.state['q'+q1.value][4]}
                          InputProps={{inputProps: {  max: 200, min: 0 }}}
                          onChange={(e) => this.handleChange3(e, q1.value, 4)}
                          variant="outlined" />
                        </div>
                      </div>
                      </>}

                      <div className="small-12 medium-12 columns">
                        <div className="sep_line_gen1">&nbsp;</div>
                      </div>
                    </>)}
                    </div>
                </div>
              </div>
          </div>
        </div>
        <div className="small-12 columns box2_1 bold">
            <p>Have you used any of the following services in the <u>past 3 months</u>?</p>
        </div>
        <div className="small-12 columns ">
          <div className="box_border5 p_csi">
              <div className="row">
                <div className="small-12 columns box1">
                  <div className="title_topic1">TYPE OF SERVICE</div>
                  <div className="row top_space">
                  {question2.map(q1 => <>
                    <div className="small-12 medium-8 columns">{q1.label}</div>
                    {no_yes.map(ny =>
                      <div className="small-12 medium-2 columns ">
                      <label class="radio‐flex">
                      <input type="radio" name={'q'+q1.value} key={"ans"+q1.value+ny.value}
                        value={ny.value} checked={this.state['q'+q1.value][0] == ny.value}
                        onChange={(e) => this.handleChange3(e, q1.value, 0)}/>
                        <span>{ny.label}</span>
                      </label></div>)}

                    {this.state['q'+q1.value][0] == 1 && <>
                    <div className="small-12 medium-12 columns">
                      <div className="sep_line_gen2">&nbsp;</div>
                    </div>
                    <div className="bottom_space1">
                      <div className="small-12 medium-5 columns frm_title1">
                      Duration/frequency of service (number of days during the past 90
days service was used.)</div>
                      <div className="small-12 medium-2 columns stay_left">
                      <TextField name={'q'+q1.value+'frequency'} type='number'
                      value={this.state['q'+q1.value][1]}
                        InputProps={{inputProps: {  max: 100, min: 0 }}}
                        onChange={(e) => this.handleChange3(e, q1.value, 1)}
                        variant="outlined" />
                      </div>
                    </div>
                    <div className="bottom_space1">
                      <div className="small-12 medium-5 columns frm_title1">Reason for service</div>
                      <div className="small-12 medium-7 columns">
                      <FormControl variant="outlined" >
                        <Select value={this.state['q'+q1.value][2]} variant="outlined"
                          label="" defaultValue=""
                          onChange={(e) => this.handleChange3(e, q1.value, 2)}>
                            {reason_service_q2.map(each =>
                              <MenuItem key={"provider"+q1.value+each.value} value={each.value}>{each.label}</MenuItem>
                            )}
                        </Select>
                      </FormControl>
                      </div>
                    </div>
                    {this.state['q'+q1.value][2] == 6 &&
                    <div className="bottom_space1">
                      <div className="small-12 medium-5 columns frm_title1">&nbsp;</div>
                      <div className="small-12 medium-7 columns stay_left">
                      <TextField name={'q'+q1.value+'reason2'} type='text' className="w100p"
                      value={this.state['q'+q1.value][3]}
                      InputProps={{ inputProps: { name: 'q'+q1.value+'reason2', maxLength: 150, placeholder: 'Please specify reason', }}}
                      onChange={(e) => this.handleChange3(e, q1.value, 3)}
                        variant="outlined" />
                      </div>
                    </div>}
                    </>}

                    <div className="small-12 medium-12 columns">
                      <div className="sep_line_gen1">&nbsp;</div>
                    </div>
                  </>)}
                  </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="small-12 columns align_right">
          {this.state.status_submit &&
            <Button variant="contained" color="primary"
             onClick={this.handleSubmit} type="submit" className="submit_1">
              Submit
            </Button>}
          {!this.state.status_submit &&
            <Button variant="contained" color="primary"
             onClick={this.handleSubmit} type="submit" className="submit_1">
              Next
            </Button>}
          </div>
        </div>

      </div>
      </form>
    </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
  onLoadLocation(route, msg) {
    dispatch(loadLocationWithMessage(route, msg))
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(CsiRedoWoLogin)
